export default __webpack_public_path__ + "static/media/uber-eats-logo-0.1fef3e90.png";